import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function (e) {
    const homeHeaderHighlights = e.target.querySelector('.home-header__highlights')

    if (homeHeaderHighlights) {
        const splideInstance = new Splide('.js-highlights-slider', {
            arrows: false,
            pagination: false,
            gap: '30px',
            autoWidth : true,
            perMove : 1,
            breakpoints: {
                991: {
                    perPage: 2,
                    autoWidth : false,
                    gap: '10px',
                    padding: { right: '5%' },
                },
                719: {
                    perPage: 1,
                    padding: { right: '0%' },
                }
            }
        })
        splideInstance.mount()
    }
})
